export function validatePhoneNumber(phoneNumber) {
    if (phoneNumber === null || phoneNumber === '') {
        return true; // Allowing null or empty string
    }
    const phoneRegex = /^(?:\+|0)[0-9]{10,14}$/;
    return phoneRegex.test(phoneNumber);
}